import * as stockview from 'modules/stockcompare/services'

import state from './stockcompare-dashboard.state'

export default {
  async load({ getters, rootGetters, commit, dispatch }) {
    const makes = rootGetters['auth/makes']
    const isAdmin = rootGetters['auth/isAdmin']

    if (isAdmin) {
      const allMakes = await stockview.getSellers()
      commit('setMakes', allMakes)
    } else if (makes.length) {
      commit('setMakes', makes)
    }
  },
  reset({ commit }) {
    commit('reset', state())
  },
  changeMyMake({ commit, dispatch }, result) {
    if (result.primary) {
      commit('changeMyMake', result.value)
    } else {
      commit('changeCompetitorMake', result.value)
    }
  }
}
